import req from '@sportninja/common/api/request'
import { useCallback, useState } from 'react'

export interface MembershipSummary {
  organizations: number
  schedules: number
  teams: number
}

export type SummaryMembershipType = 'permission' | 'following' | 'both'

export const useUsersMeSummary = () => {
  const [loading, setLoading] = useState<boolean>(false)
  const [error, setError] = useState<Error | null>(null)

  const fetchSummary = useCallback(
    async (
      membershipType: SummaryMembershipType
    ): Promise<MembershipSummary | null> => {
      setLoading(true)
      setError(null)
      try {
        const response = await req('/users/me2/summary', {
          query: { membership_type: membershipType },
        })
        return response.data as MembershipSummary
      } catch (err) {
        setError(
          err instanceof Error ? err : new Error('Failed to fetch summary')
        )
        return null
      } finally {
        setLoading(false)
      }
    },
    []
  )

  return { fetchSummary, loading, error }
}
